import * as React from 'react';

const MoveSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="move_svg__eds-icon--move_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="move_svg__eds-icon--move_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M12.5 11.5V2.8l3 3 .7-.7L12 .9 7.8 5.1l.7.7 3-3v8.7H2.8l3-3-.7-.7L.9 12l4.2 4.2.7-.7-3-3h8.7v8.7l-3-3-.7.7 4.2 4.2 4.2-4.2-.7-.7-3 3v-8.7h8.7l-3 3 .7.7 4.2-4.2-4.2-4.2-.7.7 3 3z"
        />
    </svg>
);

MoveSvg.displayName = 'MoveSvg';
export default MoveSvg;
